// extracted by mini-css-extract-plugin
export default {"message":"CustomStats_message__YXfBT"};